import {
  getCustomer,
  getMembership,
} from '../../techstyle-shared/react-accounts';
import { getSession } from '../../techstyle-shared/redux-core';

/* eslint-disable camelcase */
type FullTrackingData = {
  /** `true` when the `automated_test` cookie is found. */
  automated_test: boolean;
  dmg_code?: string;
  is_vip: boolean;
  loggedin_status: boolean;
  membership_status: string;
  session_id: string;
  store_group_id: string;
  store_id: string;
  user_id?: string;
  membership_credits: number;
  membership_tokens: number;
};
/* eslint-enable camelcase */

type TrackingDataKeys = keyof FullTrackingData;

/**
 * A utility function to get various shared tracking data.
 */
export function getFullTrackingData(nextState, context): FullTrackingData {
  const { cookies } = context;
  const { isLoggedIn, sessionId, dmGatewayCode } = getSession(
    nextState as never
  );
  const {
    availableTokenQuantity,
    isVip,
    membershipCredits,
    extendedMembershipLevelGroup,
  } = getMembership(nextState);
  const { id: userId } = getCustomer(nextState);
  const { storeGroupId, storeId } = nextState.storeGroup;

  return {
    automated_test: Boolean(cookies.get('automated_test')),
    dmg_code: dmGatewayCode ?? undefined,
    is_vip: isVip,
    loggedin_status: isLoggedIn,
    membership_status: extendedMembershipLevelGroup,
    session_id: sessionId.toString() || 'invalid session id',
    store_group_id: storeGroupId.toString(),
    store_id: storeId.toString(),
    user_id: userId ?? undefined,
    membership_credits: membershipCredits ?? 0,
    membership_tokens: availableTokenQuantity ?? 0,
  };
}

export function getPartialTrackingData<TKey extends TrackingDataKeys>(
  nextState,
  context,
  keys: TKey[]
) {
  const fullTrackingData = getFullTrackingData(nextState, context);
  const partialTrackingData = {} as Partial<FullTrackingData>;

  keys.forEach((key) => {
    partialTrackingData[key] = fullTrackingData[key];
  });

  return partialTrackingData as Pick<FullTrackingData, TKey>;
}
